import {Component, Input, OnInit} from '@angular/core';
import {AhmService} from "../../../services/ahm.service";
import {TranslateService} from "../../../services/translate.service";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input() layout = 'full';

  constructor(private service: AhmService, private translate: TranslateService) { }

  ngOnInit() {
    this.service.setTopMenuComponentLink(this);
    this.service.translateComponent(this, 'app-top-menu');
  }

  loadEventsContent() {
    this.service.eventsContent();
  }

  loadFindPsyContent() {
    this.service.psyContent();
  }

  loadConventionContent() {
    this.service.conventionContent();
  }

  loadBooksContent() {
    this.service.buyContentBlock();
  }

  loadAboutContent() {
    this.service.loadAboutContent();
  }

  loadInstrumentsContent() {
    this.service.instrumentsContent();
  }

  loadNewsContent() {
    this.service.newsContentBlock();
  }

  loadCommunityContent() {
    this.service.communityContent();
  }

  loadSupportContent() {
    this.service.supportContent();
  }

  loadWhoElseContent() {
    this.service.whoelseContent();
  }

  setLanguage(language: string) {
    if ('ru' === language) {
      this.service.setLanguageSiteVersion('rus');
      this.translate.use('ru');
    }else if ('en' === language) {
      this.service.setLanguageSiteVersion('eng');
      this.translate.use('en');

    }
  }

  loadAppsContent() {
    this.service.appsContentBlock();
  }

  loadPartnersContent() {
    this.service.appsPartnersBlock();
  }
}
